import Vue from 'vue';
import VueAxios from 'vue-axios';
import { sync } from 'vuex-router-sync';
import { get } from 'lodash';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';

import VueVirtualScroller from 'vue-virtual-scroller';
import axios from './backend/axios';
import App from './App.vue';
import { SET_ALERT, SET_SETTINGS } from './store/mutation-types';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';

Vue.config.productionTip = false;

library.add(
  ...Object.values(fal),
  ...Object.values(far),
  ...Object.values(fas),
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueVirtualScroller);

Vue.use(VueAxios, axios);

Vue.axios.interceptors.response.use((response) => {
  store.commit(SET_SETTINGS, {
    gradeDisabled: response.headers.grade_disabled === 'true',
    multipleProfiles: response.headers.multiple_profiles === 'true',
  });
  return response;
},
(error) => {
  if (!error.response || error.response.status === 401) {
    delete localStorage.authorization;
    if (!get(router, 'currentRoute.meta.public')) {
      router.replace(`/?redirect=${router.currentRoute.path}`);
    }

    if (error.message === 'Network Error') {
      store.commit(SET_ALERT, { text: 'Le serveur est indisponible' });
    } else {
      store.commit(SET_ALERT, {});
    }
  }
  if (error.response.status === 503) {
    router.push('/maintenance');
  }
  return Promise.reject(error);
});

sync(store, router);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
